import { render, staticRenderFns } from "./FormAddPaymentMethod.vue?vue&type=template&id=2ba20882&"
import script from "./FormAddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./FormAddPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports